class CustomAddedcart extends HTMLElement{
    constructor(){
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', (event)=>this.formSubmit(event));
    }
    formSubmit(event){
        event.preventDefault();
        let form = event.target;
        console.log(form);
        let formData = new FormData(form)
        console.log('FormData entries:', Array.from(formData.entries()))

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      })
        .then(function(response) {
          if (!response.ok) throw response
          return response.json()
        })
        .then(function(lineItem) {
          document.querySelector('cart-form').refresh(true);
        })
        .catch(function() {
          if (messageContainer) {
            messageContainer.textContent = ''
          }
        })
       setTimeout(()=>{
        $(document).trigger('theme:cartchanged.headerSection');
      },700)
    }
}
customElements.define('custom-addedcart', CustomAddedcart);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pbs-btn').forEach(function (btn) {

    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.dataset.variantId, 10);
      const bodyData = {
          id: variantId,
          quantity: 1
        }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(bodyData)
      })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function (lineItem) {

        // ✅ Refresh cart (Shopify theme compatible)
        var cartForm = document.querySelector('cart-form');
        if (cartForm && typeof cartForm.refresh === 'function') {
          cartForm.refresh(true);
        }

        // ✅ Open cart drawer (works in most modern themes)
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // fallback (Dawn-like themes)
          document.body.classList.add('cart-drawer-open');
        }

      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
      });
      setTimeout(()=>{
        $(document).trigger('theme:cartchanged.headerSection');
      },700)

    });

  });
});